import { useCallback, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useJobActions, { COMPLETE } from './useJobActions';
import isFieldRequired from '../functions/isRequired';
import { getAddSchema as getSchema } from '../assets/schemas/add/addSchema';

const useJobForm = (model, defaultValues) => {
  const schema = useMemo(() => getSchema(model), [model]);
  const isRequired = useCallback((id) => isFieldRequired(schema)(id), [schema]);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });
  const { reset } = methods;

  const actions = useJobActions({
    handleSubmit: methods.handleSubmit,
  });
  const { status } = actions;

  useEffect(() => {
    if (status === COMPLETE) {
      reset();
    }
  }, [status, reset]);

  return {
    methods: { ...methods, isRequired },
    actions: { ...actions },
  };
};

export default useJobForm;
